// // import "./RudrakshaSection.css";

// import { useState } from "react";

// import { Swiper, SwiperSlide } from "swiper/react";

// import { Autoplay, Navigation } from "swiper/modules";

// // import { Link } from "react-router-dom";

// import "swiper/css";
// import "swiper/css/navigation";

// import data from "../../data/conchShellData";
// import ProductCard from "../RudrakshaSection/ProductCard";
// const banners = [
//   "https://i.pinimg.com/1200x/f7/e4/f6/f7e4f62c556e724129a12d5e4719c1c6.jpg",

//   "https://i.pinimg.com/736x/f8/99/a9/f899a9b187a60274d1da7d8e9b686c4e.jpg",

//   "https://i.pinimg.com/736x/73/08/11/730811e03925f489dfac89366bf20ddc.jpg",
// ];

// export default function RudrakshaSection() {
//   const tabs = Object.keys(data);

//   const [activeTab, setActiveTab] = useState(tabs[0]);

//   return (
//     <section className="rudraksha-section">
//       <div className="container">
//         <div className="section-top">
//           <h2>Buy 100% Shankh & Sea Shells </h2>

//           <div className="tabs">
//             {tabs.map((tab) => (
//               <button
//                 key={tab}
//                 className={activeTab === tab ? "active" : ""}
//                 onClick={() => setActiveTab(tab)}
//               >
//                 {tab}
//               </button>
//             ))}
//           </div>
//         </div>

//         <div className="section-content">
//           <div className="left-banner">
//             <Swiper
//               modules={[Autoplay]}
//               loop
//               autoplay={{
//                 delay: 3000,

//                 disableOnInteraction: false,
//               }}
//             >
//               {banners.map((img, index) => (
//                 <SwiperSlide key={index}>
//                   <img src={img} alt="" />
//                 </SwiperSlide>
//               ))}
//             </Swiper>
//           </div>

//           <div className="right-products">
//              <Swiper
//               modules={[Navigation, Autoplay]}
//               navigation
//               loop={true}
//               spaceBetween={10}
//               slidesPerView={3}
//               breakpoints={{
//                 0: {
//                   slidesPerView: 2,
//                   spaceBetween: 10,
//                 },
//                 576: {
//                   slidesPerView: 2,
//                   spaceBetween: 12,
//                 },
//                 768: {
//                   slidesPerView: 2,
//                   spaceBetween: 15,
//                 },
//                 1200: {
//                   slidesPerView: 3,
//                   spaceBetween: 20,
//                 },
//               }}
//             >
//               {/* {data[activeTab].map((product) => (
//                 <SwiperSlide key={product.id}>
//                   <Link to={`/product/${product.id}`} className="product-card">
//                     <img src={product.image} alt="" />

//                     <h4>{product.title}</h4>

//                     <p>From {product.price}</p>

//                     <button>View Details</button>
//                   </Link>
//                 </SwiperSlide> */}
//               {data[activeTab].map((product) => (
//                 <SwiperSlide key={product.id}>
//                   <ProductCard product={product} />
//                 </SwiperSlide>
//               ))}
//               {/* ))} */}
//             </Swiper>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }

// api integrate

import { useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";
const SHANKH_CATEGORY_SLUG = "shankh-sea-shells";
const banners = [
  "https://i.pinimg.com/1200x/f7/e4/f6/f7e4f62c556e724129a12d5e4719c1c6.jpg",

  "https://i.pinimg.com/736x/f8/99/a9/f899a9b187a60274d1da7d8e9b686c4e.jpg",

  "https://i.pinimg.com/736x/73/08/11/730811e03925f489dfac89366bf20ddc.jpg",
];

export default function ShankhSeaShellsSection() {
  const [shankhCategory, setShankhCategory] = useState(null);

  const [subcategories, setSubcategories] = useState([]);

  const [activeSubcategory, setActiveSubcategory] = useState(null);

  const [products, setProducts] = useState([]);

  const [loadingCategories, setLoadingCategories] = useState(true);

  const [loadingProducts, setLoadingProducts] = useState(false);

  useEffect(() => {
    const fetchShankhCategory = async () => {
      try {
        setLoadingCategories(true);

        // GET ALL CATEGORIES
        const result = await getCategories();

        console.log("All Categories:", result);

        if (!result?.success) {
          setShankhCategory(null);
          setSubcategories([]);

          return;
        }

        const categories = result?.data || [];

        const shankh = categories.find(
          (category) =>
            category?.slug?.toLowerCase() ===
            SHANKH_CATEGORY_SLUG.toLowerCase(),
        );

        console.log("Shankh Category:", shankh);

        if (!shankh) {
          console.error("Shankh & Sea Shells category not found");

          setShankhCategory(null);
          setSubcategories([]);

          return;
        }

        setShankhCategory(shankh);

        if (Array.isArray(shankh.subcategories)) {
          setSubcategories(shankh.subcategories);
        } else {
          const subResponse = await fetch(
            `${API_BASE_URL}/categories/${shankh.id}/subcategories`,
          );

          const subResult = await subResponse.json();

          console.log("Shankh Subcategories:", subResult);

          if (subResult?.success) {
            setSubcategories(subResult.data || []);
          } else {
            setSubcategories([]);
          }
        }
      } catch (error) {
        console.error("Shankh Category API Error:", error);

        setShankhCategory(null);
        setSubcategories([]);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchShankhCategory();
  }, []);

  const fetchAllProducts = async (categoryId) => {
    try {
      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: categoryId,

        page: 1,

        limit: 12,
      });

      console.log("All Shankh Products:", result);

      if (result?.success) {
        setProducts(result?.data?.products || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Shankh Products API Error:", error);

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  const fetchProductsBySubcategory = async (subcategoryId) => {
    try {
      if (!shankhCategory?.id || !subcategoryId) {
        return;
      }

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: shankhCategory.id,

        subcategoryId: subcategoryId,

        page: 1,

        limit: 12,
      });

      console.log("Shankh Products By Subcategory:", result);

      if (result?.success) {
        setProducts(result?.data?.products || []);
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error("Shankh Subcategory Products API Error:", error);

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  useEffect(() => {
    if (shankhCategory?.id) {
      setActiveSubcategory(null);

      fetchAllProducts(shankhCategory.id);
    }
  }, [shankhCategory]);

  const handleSubcategoryClick = (subcategory) => {
    if (!subcategory?.id) return;

    setActiveSubcategory(subcategory.id);

    fetchProductsBySubcategory(subcategory.id);
  };

  const handleAllClick = () => {
    if (!shankhCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(shankhCategory.id);
  };

  return (
    <section className="rudraksha-section">
      <div className="container">
        <div className="section-top">
          <h2>Buy 100% Shankh & Sea Shells</h2>

          <div className="tabs">
            {/* ALL SHANKH */}

            <button
              type="button"
              className={activeSubcategory === null ? "active" : ""}
              onClick={handleAllClick}
              disabled={loadingCategories || !shankhCategory}
            >
              All Shankh & Sea Shells
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map((subcategory) => (
                <button
                  type="button"
                  key={subcategory.id}
                  className={
                    activeSubcategory === subcategory.id ? "active" : ""
                  }
                  onClick={() => handleSubcategoryClick(subcategory)}
                >
                  {subcategory.name}
                </button>
              ))}
          </div>
        </div>

        <div className="section-content">
          <div className="left-banner">
            <Swiper
              modules={[Autoplay]}
              loop
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
            >
              {banners.map((image, index) => (
                <SwiperSlide key={index}>
                  <img src={image} alt="Shankh & Sea Shells" />
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          <div className="right-products">
            {/* LOADING */}

            {loadingCategories || loadingProducts ? (
              <div className="loading">
                <Loader label="Loading Shankh & Sea Shells..." size={56} />
              </div>
            ) : products.length === 0 ? (
              /* NO PRODUCTS */

              <div className="loading">
                No Shankh & Sea Shells products found
              </div>
            ) : (
              <Swiper
                modules={[Navigation, Autoplay]}
                navigation
                loop={products.length > 3}
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                }}
              >
                {products.map((product) => (
                  <SwiperSlide key={product.id}>
                    <ProductCard product={product} />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
